import { FormEvent, useRef, useState } from 'react'
import styled from 'styled-components'
import { NormalFormEmailField, NormalFormPasswordField } from '../molecules'
import { Button, RowSpacer } from '../atoms'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import textsData from '@/textData/LoginScreenTexts.json'
import useUserDataContext from '@/customHooks/useUserDataContext'
import { FetchResult } from '@apollo/client'
import { useErrorHandlerContext, useOpeningElementsControllerContext } from '@/customHooks'
import { useNavigate } from 'react-router'
import { pathURL } from '@/components/constants/urls'
import { WarnText } from '../atoms/WarnText'
import {
  ClientAppTypeOption,
  LoginMutation,
  ResponseType,
  useLoginMutation,
  UserTypeOption,
} from '@/graphql/generated'
import { Col, Row } from 'react-grid-system'

type UserDataProps = {
  email: string | null
  password: string | null
}

const FormContainer = styled.form`
  margin: 0 auto;
  padding: 20px;
  width: 80%;
`;

export const LoginForm = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es.login : textsData.en.login
  
  const userDataRef = useRef<UserDataProps>({ email: null, password: null })

  const [isWarnTextHidden, setIsWarnTextHidden] = useState(true)

  const { setUserData: setLocalUserData } = useUserDataContext()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()
  
  const [loginAction, {loading}] = useLoginMutation()

  const { open: errorHandle } = useErrorHandlerContext()

  const navigate = useNavigate()

  const onSuccessHandle = (response: FetchResult<LoginMutation>) => {
    const loginResponse = response.data?.login
    
    if (!loginResponse) return

    switch (loginResponse?.__typename) {
      case 'LoginResponse': {
        if (
          (loginResponse.userType === UserTypeOption.Tenant) ||
          (loginResponse.userType === UserTypeOption.Owner) ||
          (loginResponse.userType === UserTypeOption.Supplier)
        ) {
          confirmDialogModalOpen({
            title: 'A problem Ocurr',
            description: 'Your user do not have privileges to login' 
          })
          console.log('Your user is do not have privileges to login')
          return
        }

        setLocalUserData({
          token: loginResponse.token ?? '',
          username: loginResponse.username ?? '',
          usertype: loginResponse.userType ?? '',
        })
        navigate(`/${pathURL.USER}`)
        return
      }
      case 'ActionResponseMessageOutput': {
        if (loginResponse.responseType === ResponseType.Failed) {
          setIsWarnTextHidden(false)
          console.warn(`Failed operation, code: ${loginResponse.code}, message: ${loginResponse.message}`)
        }
      }
    }
    /* 
    // clearErrorState()
    switch (response.data?.login.userType ?? '') {
      case UserTypeOption.Manager:
        navigate(`/${pathURL.USER}`)
        break;

      case UserTypeOption.Tenant:
        confirmDialogModalOpen({
          title: 'A problem Ocurr',
          description: 'Your user do not have privileges to login' 
        })
        console.log('Your user is do not have privileges to login')
        return

      case UserTypeOption.Owner:
        confirmDialogModalOpen({
          title: 'Hubo un problema',
          description: 'Your user do not have privileges to login' 
        })
        console.log('Your user is do not have privileges to login')
        return

      default:
        console.warn('Invalid usertype')
        return
    }

    setLocalUserData({
      token: response.data?.login.token ?? '',
      username: response.data?.login.username ?? '',
      usertype: response.data?.login.userType ?? '',
    })
     */
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault(); 
    
    loginAction({ variables: {
      email: userDataRef.current.email ?? '',
      password: userDataRef.current.password ?? '',
      clientType: ClientAppTypeOption.Manager, // Obligated from this UI
    } })
    .then(onSuccessHandle)
    .catch(errorHandle);
  };

  const onChangeHandle = (key: keyof UserDataProps, value: string | null) => {
    userDataRef.current[key] = value
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Row>
        <Col>
          <NormalFormEmailField
            required
            label={texts.user}
            name="email"
            placeholder={texts.userPlaceholder}
            onChange={(value) => onChangeHandle('email', value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormPasswordField
            required
            name="password"
            placeholder={texts.passwordPlaceholder}
            label={texts.password}
            onChange={(value) => onChangeHandle('password', value)}
          />
        </Col>
      </Row>
      <WarnText
        hidden={isWarnTextHidden}
        text={texts.warnText}
      />
      <RowSpacer height={3} />
      <Button submit upperCased isLoading={loading}>{texts.button}</Button>
    </FormContainer>
  )
};
